import React from 'react'
import { thi_catalog } from '../../../../escalas/thi/thi.catalog'

// USED IN: doctorViews/expedientes/visitas-details/escalas-emt.jsx

// Example of "thi": [ 1, 0, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1 ]

// Response options: ["Si", "A veces", "No"]

const resps = ["Si", "A veces", "No"]
const points = [4, 2, 0] // Si=4, A veces=2, No=0

function getThiGrade(score) {
  if (score <= 16) return 'Grado 1 - Leve'
  if (score <= 36) return 'Grado 2 - Leve'
  if (score <= 56) return 'Grado 3 - Moderado'
  if (score <= 76) return 'Grado 4 - Severo'
  return 'Grado 5 - Catastrófico'
}

export default function ThiResults({ thi }) {
  if (!thi) return null

  const score = thi.reduce((acc, v) => acc + points[v], 0)

  return (
    <div>
      <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
        <td><strong>Puntuación total: {score} / 100</strong></td>
        <td><strong>{getThiGrade(score)}</strong></td>
      </tr>
      {thi_catalog.map((pr, i) => (
        <tr key={i} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
          <td>{pr}</td>
          <td>{resps[thi[i]]}</td>
        </tr>
      ))}
    </div>
  )
}
